import React, { FC, useEffect, useState } from 'react';

import { OL_MAP_ROTATION_KEY } from 'constants/storage';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { localStorage as storage } from 'core/app/storage';
import { getOwMap } from 'core/react/general/location/Map';
import { MAP_DEFAULT_ROTATION_DEGREES, MAP_DEFAULT_ROTATION_RADIANS } from 'constants/map';
import { arrowRampLeft, arrowRampRight, compass } from 'assets/icons';

import styles from './styles.module.css';

interface ICompassProps {
  mapName: string;
}

export const Compass: FC<ICompassProps> = ({ mapName }) => {
  const [rotation, setRotation] = useState(() => {
    const storedRotation = storage.get(OL_MAP_ROTATION_KEY);

    return (!storedRotation && storedRotation !== 0 ? MAP_DEFAULT_ROTATION_RADIANS : storedRotation) * (180 / Math.PI);
  });

  const onRotate = (rotation: number) => {
    setRotation(rotation * (180 / Math.PI));
  };

  const updateRotation = (rotation: number) => {
    onRotate(rotation);
    getOwMap(mapName).rotateMap(rotation * (Math.PI / 180));
  };

  const resetRotation = () => {
    if (rotation.toFixed(0) !== `${MAP_DEFAULT_ROTATION_DEGREES}`) {
      updateRotation(1.171 * (180 / Math.PI));
    }
  };

  const normalizeRotation = (deg: number) => ((deg % 360) + 360) % 360;

  const handleLeftRotation = () => {
    updateRotation(normalizeRotation(rotation - 90));
  };

  const handleRightRotation = () => {
    updateRotation(normalizeRotation(rotation + 90));
  };

  useEffect(() => {
    getOwMap(mapName).subscribeRotation(onRotate);

    return () => {
      // eslint-disable-next-line no-unused-expressions
      getOwMap(mapName)?.unsubscribeRotation(onRotate);
    };
  });

  return (
    <div className={styles.compass}>
      <SvgWrapper
        width={48}
        height={48}
        details={compass}
        style={{ transform: `rotate(${-45 + rotation}deg)`, overflow: 'visible' }}
        onClick={resetRotation}
      />
      <SvgWrapper
        width={24}
        height={24}
        details={arrowRampLeft}
        color="transparent"
        className={styles.leftArrow}
        onClick={handleLeftRotation}
      />
      <SvgWrapper
        width={24}
        height={24}
        details={arrowRampRight}
        color="transparent"
        className={styles.rightArrow}
        onClick={handleRightRotation}
      />
    </div>
  );
};
